/// <amd-module name="SuiteCommerce.GiftCertificate.GiftCertificatesList.Button.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.GiftCertificatesList.Button.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.GiftCertificatesList.Configuration", "SuiteCommerce.GiftCertificate.Common.FeedbackMessageManager", "gift_certificates_list_row_button.tpl"], function (require, exports, Backbone_1, GiftCertificatesList_Configuration_1, FeedbackMessageManager_1, giftCertificatesButtonTpl) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GiftCertificateButtonView = void 0;
    var GiftCertificateButtonView = /** @class */ (function (_super) {
        __extends(GiftCertificateButtonView, _super);
        function GiftCertificateButtonView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = giftCertificatesButtonTpl;
            _this.isRemoved = false;
            _this.events = {
                'click [data-action="remove-gift-certificate"]': 'removeGiftCertificate',
            };
            _this.parentCollection = options.parentCollection;
            return _this;
        }
        GiftCertificateButtonView.prototype.removeGiftCertificate = function () {
            var _this = this;
            this.isRemoved = !this.isRemoved;
            var requestObj;
            if (this.isRemoved) {
                requestObj = this.model.destroy({}).done(function () {
                    FeedbackMessageManager_1.FeedbackMessageManager.triggerMessageEvent({
                        context: _this,
                        type: FeedbackMessageManager_1.FeedbackMessageType.SUCCESS,
                        message: GiftCertificatesList_Configuration_1.GiftCertificatesListConfiguration.codeRemovedMessage,
                    });
                });
            }
            else {
                requestObj = this.model.save({}).done(function () {
                    FeedbackMessageManager_1.FeedbackMessageManager.triggerRemoveMessageEvent(_this);
                    _this.parentCollection.add(requestObj.responseJSON, { silent: true });
                });
            }
            this.render();
        };
        GiftCertificateButtonView.prototype.getContext = function () {
            return {
                isRemoved: this.isRemoved,
                removeLabel: GiftCertificatesList_Configuration_1.GiftCertificatesListConfiguration.tableRemoveLabel,
                undoLabel: GiftCertificatesList_Configuration_1.GiftCertificatesListConfiguration.tableUndoLabel,
            };
        };
        return GiftCertificateButtonView;
    }(Backbone_1.View));
    exports.GiftCertificateButtonView = GiftCertificateButtonView;
});
